<template>
    <div>
        <backendBlock v-if="blockType === 'BackendBlock'"
                      v-bind:block="block"
                      v-bind:options="options"
                      v-bind:currentBlocks="currentBlocks"
                      @deleteBlock="deleteBlock()"/>
        <CustomBlock v-if="blockType === 'CustomBlock'"
                     v-bind:block.sync="block"
                     v-bind:options="options"
                     v-bind:currentBlocks="currentBlocks"
                     @deleteBlock="deleteBlock()"/>
    </div>
</template>
<script>
    import CustomBlock from "./BlockTypes/CustomBlock";
    import BackendBlock from "./BlockTypes/BackendBlock";

    export default {
        components: {
            CustomBlock,
            BackendBlock
        },
        props: {
            block: {
                type: Object,
                default: {}
            },
            options: {
                type: Array,
                default: []
            },
            currentBlocks: {
                type: Array,
                default: []
            },
            blockType: {
                type: String,
                default: ""
            }
        },
        methods: {
            deleteBlock() {
                this.$emit('deleteBlock');
            }
        }
    }
</script>

<style>
    .expansion {
        margin: 2px;
    }

    .expansion > button {
        padding: 5px;
    }

    .expansionHeaderText {
        display: flex;
        align-items: center;
    }

    .expansionHeaderText > p {
        margin-bottom: 0;
    }

    .colLowPadding {
        padding: 5px;
    }
</style>
